// libs/react-mosaic-component/src/lib/buttons/DefaultAddTabButton.tsx
import classNames from "classnames";
import React from "react";
import { MosaicContext } from "../contextTypes.mjs";
var DefaultAddTabButton = ({
  path,
  className,
  title = "Add new tab",
  ariaLabel = "Add new tab",
  children = "+"
}) => {
  const { mosaicActions } = React.useContext(MosaicContext);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: classNames("mosaic-tab-add-button", className),
      onClick: () => {
        mosaicActions.addTab(path).catch((err) => console.error(err));
      },
      "aria-label": ariaLabel,
      title
    },
    children
  );
};
export {
  DefaultAddTabButton
};
